import React from "react";

const GuarantorLoanApplicationSuccess = ({
  isGuarantorLoanApplicationSuccessOpen,
  closeGuarantorLoanApplicationSuccess,
}) => {
  if (!isGuarantorLoanApplicationSuccessOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-10">
      <div className="bg-white rounded-sm shadow-xl w-[670px] h-[340px] flex flex-col items-center justify-center p-8 text-center">
        <div className="mb-6 flex items-center justify-center w-[76px] h-[76px] rounded-full bg-blue-100">
          <div className="bg-blue-100 p-3 rounded-full">
            <img
              src="/blue-tick.png"
              alt="Awaiting Approval"
              className="w-12 h-12"
            />
          </div>
        </div>

        <h2 className="text-xl font-semibold text-gray-900 mb-3">
          Loan Application Successful!
        </h2>

        <p className="text-gray-600 text-sm mb-8 max-w-[420px] leading-relaxed">
          The loan application has been submitted successfully and is now
          pending approval. Visit the Guarantor section of the Loan to upload
          the Guarantor consent form.
        </p>

        <div className="flex justify-center items-center mt-6">
          <button
            className="bg-[#074073] text-white text-[14px] w-[211px] h-[49px] rounded-md font-medium whitespace-nowrap hover:bg-[#062f55] transition-colors duration-200"
            onClick={closeGuarantorLoanApplicationSuccess}
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
};

export default GuarantorLoanApplicationSuccess;
